import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import {
  IGetRegionalSaleAdminResponse,
  IGetStaffByRoleParams,
  IStaffParams,
  IStaffResult,
} from 'interfaces';

const getStaff = (params: IStaffParams): Promise<IStaffResult> => {
  return bffServiceClient.get('/staff/children', { params }).then(getResult);
};

const getStaffByRole = (
  params: IGetStaffByRoleParams
): Promise<IStaffResult> => {
  return bffServiceClient.get('/staff', { params }).then(getResult);
};

const getRegionalSaleAdmin = (): Promise<IGetRegionalSaleAdminResponse> => {
  return bffServiceClient.get('/staffLocation').then(getResult);
};

const assignSaleAdmin = (payload: {
  provinceCode: string;
  staffId?: number;
}): Promise<{}> => {
  return bffServiceClient.post('/staffLocation', payload);
};

export default {
  getStaff,
  getStaffByRole,
  getRegionalSaleAdmin,
  assignSaleAdmin,
};
